import { render, staticRenderFns } from "./DiscountCampaigns.vue?vue&type=template&id=63c3c38a"
import script from "./DiscountCampaigns.vue?vue&type=script&lang=js"
export * from "./DiscountCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports